// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"279":"558df96011758af8","7156":"b45d925f958427b7","9343":"e1a185d25314cae3"}[chunkId] + ".css";
};